<template>
    <v-container>
            <v-row class=" d-flex justify-space-between">
                    <div class="text-h4 mb-5 mt-5">Registros</div>
                    <v-alert dense outlined text class="text-center mb-4 mt-4 pb-0 pt-0 align-self-center" color="blue darken-1" v-if="filtroActivo" width="300">
                        Filtro de búsqueda activo 
                        <v-btn icon color="blue darken-1" @click="todosLosRegistros(), filtroActivo = false" class="ml-5"><v-icon>mdi-close-thick</v-icon></v-btn>
                    </v-alert>
            </v-row>
            <v-card :loading="loading">
                <v-card-title>
                    <v-text-field
                        v-model="buscar"
                        append-icon="mdi-file-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="registros" :search="buscar" :footer-props="footerProps">
                    <template v-slot:item.ip_confiable="{ item }">
                        <v-chip :color="getColorIpConfiable(item.ip_confiable)" outlined pill small>
                            {{ getValorIpConfiable(item.ip_confiable) }}
                        </v-chip>
                    </template>
                    <template v-slot:item.created_at="{ item }">
                            {{ formatearFecha(item.created_at) }}
                    </template>
                    <template v-slot:item.nivel_seguridad="{ item }">
                        <v-chip :color="getColorNivelSeguridad(item.nivel_seguridad)" outlined pill small>
                            {{ getValorNivelSeguridad(item.nivel_seguridad) }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <v-speed-dial v-model="fab" fixed direction="top" :transition="transition" style="bottom: 37px; right: 30px;">
            <template v-slot:activator>
                <v-btn v-model="fab" color="accent" dark fab>
                    <v-icon v-if="fab">mdi-close</v-icon>
                    <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
            </template>
            <v-btn fab dark small color="indigo" @click="dialogBusquedaAvanzada = true">
                <v-icon>mdi-layers-search-outline</v-icon>
            </v-btn>
        </v-speed-dial>
        <v-dialog v-model="dialogBusquedaAvanzada" max-width="500px" persistent>
            <v-card>
                <v-card-title>Búsqueda Avanzada</v-card-title>
                <v-card-text>
                    <v-row class="mt-2" dense>
                        <v-col cols="12">
                            <v-text-field 
                                label="IP" 
                                filled 
                                color="blue-grey lighten-2" 
                                v-model="datosBusqueda.ip" 
                                @blur="$v.datosBusqueda.ip.$touch()"
                                @input="$v.datosBusqueda.ip.$touch()"
                                :error-messages="errorIP" 
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-dialog ref="dialogFechaInicio" v-model="modalFechaInicio" :return-value.sync="fechaI" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field 
                                        v-model="datosBusqueda.fechaInicio" 
                                        label="Fecha inicio" v-bind="attrs" 
                                        v-on="on"  
                                        @blur="fechaI = parseDate(datosBusqueda.fechaInicio)"
                                        readonly
                                        filled
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaI" scrollable :first-day-of-week="1">
                                    <v-btn text color="error" @click="modalFechaInicio = false, $refs.dialogFechaInicio.save(fechaI), delete datosBusqueda.fechaInicio">Borrar</v-btn>    
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="modalFechaInicio = false">Cancelar</v-btn>
                                    <v-btn text color="primary" class="ml-0" @click="$refs.dialogFechaInicio.save(fechaI)">Aceptar</v-btn>
                                </v-date-picker>
                            </v-dialog>
                            <v-text-field 
                                label="Código país" 
                                filled color="blue-grey lighten-2" 
                                v-model="datosBusqueda.codigo"
                                @blur="$v.datosBusqueda.codigo.$touch()"
                                @input="$v.datosBusqueda.codigo.$touch()"
                                :error-messages="errorCodigo"
                            />
                            <v-select label="Nivel de seguridad" filled :items="niveles" v-model="datosBusqueda.nivel" color="blue-grey lighten-2"></v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-dialog ref="dialogFechaFin" v-model="modalFechaFin" :return-value.sync="fechaF" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field 
                                    color="blue-grey lighten-2"
                                    v-model="datosBusqueda.fechaFin" 
                                    label="Fecha fin" v-bind="attrs" 
                                    v-on="on"  
                                    @blur="fechaF = parseDate(datosBusqueda.fechaFin)"
                                    readonly
                                    filled
                                ></v-text-field>
                                </template>
                                <v-date-picker v-model="fechaF" scrollable :first-day-of-week="1">
                                <v-btn text color="error" @click="modalFechaFin = false, $refs.dialogFechaInicio.save(fechaF), delete datosBusqueda.fechaFin">Borrar</v-btn>  
                                <v-spacer></v-spacer>
                                <v-btn text @click="modalFechaFin = false">Cancelar</v-btn>
                                <v-btn text color="primary" class="ml-0" @click="$refs.dialogFechaFin.save(fechaF)">Aceptar</v-btn>
                                </v-date-picker>
                            </v-dialog>
                            <v-text-field label="Ciudad" filled color="blue-grey lighten-2" v-model="datosBusqueda.ciudad"/>
                            <v-select label="IP de confianza" filled :items="confianza" v-model="datosBusqueda.confianza" color="blue-grey lighten-2"></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="finBusqueda()">Cancelar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="busquedaAvanzada()"
                        :disabled="$v.datosBusqueda.$invalid"
                    >Aceptar</v-btn>
                </v-card-actions>
                <v-dialog v-model="dialogFechas" persistent max-width="380">
                    <v-card>
                        <v-card-title class="headline">Error de fecha</v-card-title>
                        <v-card-text>La fecha de inicio debe ser anteriror a la fecha final</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" text @click="dialogFechas = false">Aceptar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';
    import { ipAddress, minLength, maxLength } from 'vuelidate/lib/validators';
    import formatearFecha from '../../mixins/formatearFecha';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'Registros',
        mixins: [formatearFecha],
        data: () => ({
            fab: false,
            transition: 'slide-y-reverse-transition',
            registros: [],
            buscar: '',
            headers: [
                {
                    text: 'Fecha',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'created_at'
                },
                {
                    text: 'IP',
                    filterable: true,
                    sortable: true,
                    value: 'ip',
                },
                {
                    text: 'Código país',
                    filterable: true,
                    sortable: true,
                    value: 'country_code'
                },
                {
                    text: 'Ciudad',
                    filterable: false,
                    sortable: false,
                    value: 'city'
                },
                {
                    text: 'Nivel de seguridad',
                    filterable: true,
                    sortable: true,
                    value: 'nivel_seguridad'
                },
                {
                    text: 'IP confianza',
                    filterable: true,
                    sortable: true,
                    value: 'ip_confiable'
                }
            ],
            niveles: ['', 'De confianza', 'Riesgo medio', 'Riesgo alto', 'No identificado'],
            confianza: ['', 'Si', 'No'],
            loading: false,
            dialogBusquedaAvanzada: false,
            datosBusqueda:{},
            modalFechaInicio: false,
            fechaI:'',
            modalFechaFin: false,
            fechaF:'',
            filtroActivo: false,
            dialogFechas: false,
            footerProps: {'items-per-page-options': [50, 100, -1]},
        }),
        validations: {
            datosBusqueda: {
                ip: { ipAddress },
                codigo: {minLength: minLength(2), maxLength: maxLength(2)}
            }
        },
        methods: {
            ...mapActions(['setLoading']),
            getColorIpConfiable(confiable){
                return confiable == '1' ? 'success' : 'orange darken-2'
            },
            getValorIpConfiable(confiable){
                return confiable == '1' ? 'SI' : 'NO'
            },
            getColorNivelSeguridad(nivel){
                if (nivel === 0){return 'grey darken-1'}
                else if (nivel === 1){return 'success'}
                else if (nivel === 2){return 'orange darken-2'}
                else if (nivel === 3){return 'error'}
                else if (nivel === 99){return 'warning'}
            },
            getValorNivelSeguridad(nivel){
                if (nivel === 0){return 'Desconocido'}
                else if (nivel === 1){return 'De confianza'}
                else if (nivel === 2){return 'Riesgo medio'}
                else if (nivel === 3){return 'Riesgo alto'}
                else if (nivel === 99){return 'No identificado'}
            },
            busquedaAvanzada(){
                if (this.datosBusqueda.fechaInicio && this.datosBusqueda.fechaFin){
                    var fI = this.datosBusqueda.fechaInicio.split('/');
                    var fF = this.datosBusqueda.fechaFin.split('/');
                    var fFecha1 = Date.UTC(fI[2],fI[1]-1,fI[0]);
                    var fFecha2 = Date.UTC(fF[2],fF[1]-1,fF[0]);
                    var dif = fFecha2 - fFecha1;
                    var dias = Math.floor(dif / (1000 * 60 * 60 * 24));
                }
                if (!dias || dias >= 0){
                    this.setLoading(true);
                    if (this.datosBusqueda.fechaInicio){
                        this.datosBusqueda.fechaInicio = this.parseDate(this.datosBusqueda.fechaInicio) + ' 00:00:00';
                    }
                    if (this.datosBusqueda.fechaFin){
                        this.datosBusqueda.fechaFin = this.parseDate(this.datosBusqueda.fechaFin) + ' 24:59:59';
                    }
                    if (this.datosBusqueda.nivel){
                        if (this.datosBusqueda.nivel === 'Desconocido'){this.datosBusqueda.nivel = 0}
                        else if (this.datosBusqueda.nivel === 'De confianza'){this.datosBusqueda.nivel = 1}
                        else if (this.datosBusqueda.nivel === 'Riesgo medio'){this.datosBusqueda.nivel = 2}
                        else if (this.datosBusqueda.nivel === 'Riesgo alto'){this.datosBusqueda.nivel = 3}
                        else if (this.datosBusqueda.nivel === 'No identificado'){this.datosBusqueda.nivel = 99}
                    }
                    axios.get(`/api/registros?
                        ip=${this.datosBusqueda.ip}&
                        fechaInicio=${this.datosBusqueda.fechaInicio}&
                        fechaFin=${this.datosBusqueda.fechaFin}&
                        codigo=${this.datosBusqueda.codigo}&
                        ciudad=${this.datosBusqueda.ciudad}&
                        nivel=${this.datosBusqueda.nivel}&
                        confianza=${this.datosBusqueda.confianza}`
                    ).then(response => {
                        this.registros = Object.values(response.data);
                        this.filtroActivo = false;
                        this.comprobarFiltro();
                        this.finBusqueda();
                        this.setLoading(false);
                    }).catch(error => { 
                        this.setLoading(false);
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'error',
                            mensaje: 'Error. No se han podido obtener los registros de la búsqueda'
                        });
                    });
                }else{
                    this.dialogFechas = true;
                }
            },
            comprobarFiltro(){
                if(this.datosBusqueda !== {}){
                    for (const dato in this.datosBusqueda) {
                        if(this.datosBusqueda[dato] !== '' && this.datosBusqueda[dato] !== undefined){
                            this.filtroActivo = true;
                        }
                    }
                }
            },
            finBusqueda(){
                this.dialogBusquedaAvanzada = false;
                this.datosBusqueda = {};
                this.$v.$reset();
            },
            formatDate (fecha) { //cambiamos el formato de la fecha de YYYY-MM-DD a DD/MM/YYYY
                if(fecha){
                    const [year, month, day] = fecha.split('-')
                    return `${day}/${month}/${year}`
                }
            },
            parseDate (fecha) { //cambiamos el formato de la fecha de DD/MM/YYYY a YYYY-MM-DD
                if(fecha){
                    const [day, month, year] = fecha.split('/')
                    return `${year}-${month}-${day}`      
                }        
            },
            todosLosRegistros(){
                this.loading = true;
                axios.get("/api/registros").then(respuesta => {
                    this.loading = false;
                    this.registros = respuesta.data;
                }).catch(error =>{
                    this.loading = false;
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'No se han podido recuperar los registros'
                    });
                });
            }
        },
        mounted() {
            this.todosLosRegistros();
        },
        watch: {
            fechaI (val) {
                this.datosBusqueda.fechaInicio = this.formatDate(this.fechaI)
            },
            fechaF (val) {
                this.datosBusqueda.fechaFin = this.formatDate(this.fechaF)
            }
        },
        computed: {
            errorIP() {
                if (this.$v.datosBusqueda.ip.$dirty){ //comprobación de si se ha hecho clic en el campo
                    if (!this.$v.datosBusqueda.ip.$ipAddress && this.$v.datosBusqueda.ip.$invalid){ //comprobación de si el campo no tiene format ip
                        return 'IP incorrecta';
                    }
                }
            },
            errorCodigo() {
                if (this.$v.datosBusqueda.codigo.$dirty){ //comprobación de si se ha hecho clic en el campo
                    if (this.$v.datosBusqueda.codigo.$invalid && !this.$v.datosBusqueda.codigo.$minLength && !this.$v.datosBusqueda.codigo.$maxLength){ //comprobación de si el campo es de la medida que pertoca
                        return 'El código de país tiene el siguiente formato: ES';
                    }
                }
            }
        }
    }
</script>